import { getKyClient } from './client';

export const fetchSuspensionInfo = async (adfitNo, suspensionStartDate) => {
  const url = `v1.0/accounts/${adfitNo}/suspensions/Information?suspensionStartDate=${suspensionStartDate}`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const postSuspension = async (adfitNo, data) => {
  const url = `v1.0/accounts/${adfitNo}/suspensions`;
  const kyClient = await getKyClient();
  return kyClient
    .post(url, {
      json: data,
    })
    .json();
};

export const fetchSuspension = async (adfitNo, scheduleSuspenseId) => {
  const url = `v1.0/accounts/${adfitNo}/suspensions/${scheduleSuspenseId}`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const putSuspension = async (adfitNo, scheduleSuspenseId, data) => {
  const url = `v1.0/accounts/${adfitNo}/suspensions/${scheduleSuspenseId}`;
  const kyClient = await getKyClient();
  return kyClient
    .put(url, {
      json: data,
    })
    .json();
};
